import React from "react"
import chiken from "../assets/chiken.png";
import pork from "../assets/pork.png";
import fish from "../assets/fish.png";
import turkey from "../assets/turkey.png";
import burguer from "../assets/burguer.png";
import steak from "../assets/steak.png";
import "../styles/selectProgram.css";
import "../styles/basicLayout.css"
import { CATEGORIES } from "../utils/constants";
import { mainBgColor } from "../utils/colors";

export default function CategorySelector({ category, handleSetCategory, ...params }) {

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', flex: 1, alignItems: 'flex-start' }}>

      <div 
        onClick={() => handleSetCategory(CATEGORIES.STEAK)}
        className="category" 
        style={{...(category === CATEGORIES.STEAK && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={steak}
          alt=""
        />
        <span>Steak</span>
      </div>
      <div 
        onClick={() => handleSetCategory(CATEGORIES.CHICKEN)}
        className="category" 
        style={{...(category === CATEGORIES.CHICKEN && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={chiken}
          alt=""
        />
        Chiken
      </div>
      <div 
        onClick={() => handleSetCategory(CATEGORIES.FISH)}
        className="category" 
        style={{...(category === CATEGORIES.FISH && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={fish}
          alt=""
        />
        Fish
      </div>
      <div 
        onClick={() => handleSetCategory(CATEGORIES.BURGUER)}
        className="category" 
        style={{...(category === CATEGORIES.BURGUER && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={burguer}
          alt=""
        />
        Burguer
      </div>
      <div 
        onClick={() => handleSetCategory(CATEGORIES.TURKEY)}
        className="category" 
        style={{...(category === CATEGORIES.TURKEY && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={turkey}
          alt=""
        />
        Turkey
      </div>
      <div 
        onClick={() => handleSetCategory(CATEGORIES.PORK)}
        className="category" 
        style={{...(category === CATEGORIES.PORK && { backgroundColor: mainBgColor })}}>
        <img
          width={150}
          style={{ marginBottom: 10 }}
          src={pork}
          alt=""
        />
        Pork
      </div>

    </div>
  )
}
